var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasureSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0v1.5h-3v13h3V16h-3A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.356.007L1.5 0h3zm10 0a1.5 1.5 0 0 1 1.493 1.356L16 1.5v13a1.5 1.5 0 0 1-1.356 1.493L14.5 16h-3v-1.5h3v-13h-3V0h3zM5.579 4.5 8.02 8.496 10.4 4.5h2.079L12.5 12h-2.304l-.021-3.418-1.629 2.743H7.432L5.804 8.7V12H3.5V4.5h2.079z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureSelector);
export default __webpack_public_path__ + "static/media/measure-selector.61c7a4e0c248c5c40094a9a8db8cf323.svg";
export { ForwardRef as ReactComponent };